var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterest = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E60019",
  d: "M18 0C8.1 0 0 8.1 0 18c0 7.6 4.7 14.1 11.4 16.7-.1-1.4-.3-3.6.1-5.1.3-1.4 2.1-9 2.1-9s-.5-1-.5-2.6c0-2.5 1.4-4.4 3.2-4.4 1.6 0 2.3 1.2 2.3 2.5 0 1.6-1 3.9-1.5 6-.4 1.8.9 3.3 2.7 3.3 3.2 0 5.7-3.4 5.7-8.2 0-4.4-3.1-7.4-7.6-7.4-5.1 0-8.1 3.9-8.1 7.8 0 1.6.6 3.2 1.3 4.1.2.2.2.4.1.6-.1.5-.4 1.8-.5 2 0 .3-.2.4-.6.2-2.2-1-3.6-4.3-3.6-6.9 0-5.7 4.1-10.9 11.9-10.9 6.2 0 11.1 4.4 11.1 10.4 0 6.2-3.9 11.2-9.4 11.2-1.8 0-3.5-1-4.1-2.1 0 0-.9 3.4-1.1 4.3-.4 1.5-1.5 3.5-2.3 4.7 1.7.5 3.5.8 5.4.8 9.9 0 18-8.1 18-18S28 0 18 0"
}))));
export default SvgPinterest;